
<app-not-refresh-appbar  >{{'helloword' | translate}}</app-not-refresh-appbar>

<div id="appCapsule"> 
    <div class="container" *ngIf="game != 'gameList'">
            <div class="row pt-3">
                <div class="col-12 text-center">
                    <img class="bradius" [src]="LaunchGameList.iconurl" alt="gameImage" >   
                    <h4>{{ changeLanguage(LaunchGameList)}}</h4>   
                </div>    
            </div> 
            <div class="banner__card">
                <div class="inner_card" [ngClass]="{'win': (GamePlayResult.balanceBefore - GamePlayResult.postBalance) &lt; 0, 
            'lose': (GamePlayResult.balanceBefore - GamePlayResult.postBalance) &gt; 0,
            'even': (GamePlayResult.balanceBefore - GamePlayResult.postBalance) == 0}">
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &lt; 0">{{ 'game-win' |translate}}</h5>
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &gt; 0">{{ 'game-lose' |translate}}</h5>
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) == 0">{{ 'game-even' |translate}}</h5>
                </div>                
            </div>
            <div class="card__wrapper">
                <div class="row px-3">
                <div class="col-6 d-flex">
                <img src="assets/img/wallet.png" class="game-win-lose-img" alt="" width="20px" height="20px">
                &nbsp;<h5 class="game_amount_title" >{{ 'before-game-balance' |translate}}</h5>
                </div>
                <div class="col-6 text-right" *ngIf="!loadingGameBalance"> 
                    <h5 class="game-amount">{{ GamePlayResult.balanceBefore }}&nbsp;{{ 'Ks' |translate}}</h5>
                </div>
                <div *ngIf="loadingGameBalance" >
                <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                </div>
                </div>
                <div class="row px-3">
                    <div class="col-6 d-flex ">
                    <img src="assets/img/game_wallet.png" alt="" width="20px" height="20px">
                    &nbsp;<h5 class="game_amount_title">{{ 'leave-post-game-balance' |translate}}</h5>
                    </div>
                    <div class="col-6 text-right" *ngIf="!loadingGameBalance"> 
                        <h5 class="game-amount">{{ GamePlayResult.postBalance }}&nbsp;{{ 'Ks' |translate}}</h5>
                    </div>
                    <div class="mt-2 position-relative justify-content-center" *ngIf="loadingGameBalance" >
                    <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                    </div>
                </div>
                <div class="row px-5 pb-3">                   
                    <div class="col-12 coin__div" *ngIf="!loadingGameBalance">                                                              
                            <h5 class="game-amount m-0">
                                <span class="game-amount" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &gt; 0">-</span>
                                <span class="game-amount" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &lt; 0">+</span> 
                                {{changeNumber(GamePlayResult.balanceBefore, GamePlayResult.postBalance) }}
                            </h5>
                            <img src="assets/img/coin.png" alt="" width="20" height="20">                       
                    </div>
                    <div class="mt-2 position-relative justify-content-center" *ngIf="loadingGameBalance" >
                    <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                    </div>
                </div>
            </div>
            <!-- <div class="card_div">
            <div class="row" >
                <div class="col-6 d-flex">
                <img src="assets/img/wallet.png" class="game-win-lose-img" alt="" width="20px" height="20px">
                &nbsp;<h5 class="game_amount_title" >{{ 'before-game-balance' |translate}}</h5>
                </div>
                <div class="col-6 text-right" *ngIf="!loadingGameBalance"> 
                    <h5 class="game-amount">{{ GamePlayResult.balanceBefore }}&nbsp;{{ 'Ks' |translate}}</h5>
                </div>
                <div *ngIf="loadingGameBalance" >
                <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                </div>
            </div>
            <div class="row">
                <div class="col-6 d-flex ">
                <img src="assets/img/game_wallet.png" alt="" width="20px" height="20px">
                &nbsp;<h5 class="game_amount_title">{{ 'leave-post-game-balance' |translate}}</h5>
                </div>
                <div class="col-6 text-right" *ngIf="!loadingGameBalance"> 
                    <h5 class="game-amount">{{ GamePlayResult.postBalance }}&nbsp;{{ 'Ks' |translate}}</h5>
                </div>
                <div class="mt-2 position-relative justify-content-center" *ngIf="loadingGameBalance" >
                <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                </div>
            </div>
            <div class="row">
                <div class="col-6 d-flex">
                <img src="assets/img/wallet.png" alt="" width="20px" height="20px">&nbsp;
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &lt; 0">{{ 'game-win' |translate}}</h5>
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &gt; 0">{{ 'game-lose' |translate}}</h5>
                    <h5 class="game_amount_title" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) == 0">{{ 'game-even' |translate}}</h5>
                </div>
                <div class="col-6 text-right" *ngIf="!loadingGameBalance">                   
                    <h5 class="game-amount">
                        <span class="game-amount" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &gt; 0">-</span>
                        <span class="game-amount" *ngIf="(GamePlayResult.balanceBefore - GamePlayResult.postBalance) &lt; 0">+</span> 
                         {{changeNumber(GamePlayResult.balanceBefore, GamePlayResult.postBalance) }} &nbsp;{{ 'Ks' |translate}}</h5>
                </div>
                <div class="mt-2 position-relative justify-content-center" *ngIf="loadingGameBalance" >
                <ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "false"></ngx-spinner>
                </div>
            </div>
            </div> -->
    </div>
</div>
<ngx-spinner size = "small" color = "rgb(6,56,107)" type = "ball-spin-clockwise" [fullScreen] = "true" *ngIf="game == 'gameList'"></ngx-spinner>
